import { fromUnitsToRem, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

const styles = {
  menu: {
    '.MuiMenu-list': {
      padding: 0,
    },

    '.MuiPaper-root': {
      maxWidth: '230px',
      borderRadius: '8px',
      color: YodaColors.black,
      marginTop: fromUnitsToRem(YodaSpacing.xSmall),
      overflow: 'visible',
      boxShadow: '0px -3px 20px 0px rgba(64, 83, 110, 0.3)',

      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-5px',
        left: '85%',
        transform: 'translateX(-50%) rotate(45deg)',

        width: '12px',
        height: '12px',
        backgroundColor: YodaColors.white,
      },
    },

    '.MuiMenuItem-root': {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      lineHeight: '1.3',
      alignItems: 'flex-start',
      display: 'flex',

      '& .MuiBox-root': {
        color: YodaColors.black,
        fontSize: YodaFontSize.small,
        fontWeight: YodaFontWeight.regular,
      },

      '&:first-of-type': {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
      },

      '&:last-of-type': {
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
      },
    },
  },
};

export default styles;
